import { BreadcrumbDataQuery } from '@lib/ui-components';
import {
  ReactQueryHateoasClientService,
} from '../libs/common-sdk/hateoas-rest-api-client/react-query-hateoas-client.service';

export const ProjectBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<string> {
    return function () {
      return ReactQueryHateoasClientService.findOneByAggregateId<any>('projectViews', 'projectId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'projectViews',
};
